import * as angular from "angular";
import {IController} from "angular";

export class taskStatusIconCtrl implements IController {

  status: any;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('taskStatusIcon', {
    bindings: {
      status: '<'
    },
    template: require('./task-status-icon.html').default,
    controller: taskStatusIconCtrl
  });
